var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.component === "EventInfoFilter"
    ? _c("EventInfoFilter", {
        attrs: {
          "presetfilter-values": _vm.componentProperties.presetfilterValues,
          "vendor-options": _vm.componentProperties.vendorOptions,
        },
      })
    : _vm.component === "OpDataFilter"
    ? _c("OpDataFilter")
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }